import capitalize from 'lodash/capitalize';
import groupBy from 'lodash/groupBy';
import numeral from 'numeral';
import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import Divider from '@mui/material/Divider';
/** import mui components in the section above, keep the ascending order */

import { SummaryGroup } from 'widgets/summary-view/summary-layout';
import SummaryTypeText from 'widgets/summary-view/summary-type-text';
import SummaryTypeTextCollection from 'widgets/summary-view/summary-type-text-collection';
/** import widgets components in the section above, keep the ascending order */

import { DEAL_CATEGORY_AD_DETAILS_MAPPING, DEAL_TYPE_MAPPING } from 'common/constants/deals';
import { DealCategory } from 'common/constants/deals';
import { formatDate_dateWithYear, getCurrencySignforCurrency } from 'utils/formatting';
import { isUsingGuaranteedInventoryType } from 'states/resources/campaigns/business-logic';
/** import classes and others in the section above, keep the ascending order */

const AdSummaryDeals = ({ deals, formData, campaign }) => {
    return (
        <React.Fragment>
            <SummaryTypeText
                keyName="Deals"
                value={
                    deals.length > 0 ? `${deals.length} deal(s) associated with this ad` : 'None'
                }
            />
            {/* Group deals by category and render each group */}
            {(() => {
                const groupedDeals = groupBy(deals, deal => deal.category);
                return Object.entries(groupedDeals).map(([category, deals], groupIndex) => (
                    <SummaryGroup
                        key={category}
                        groupName={DEAL_CATEGORY_AD_DETAILS_MAPPING[category]?.label || category}
                        removeDivider={groupIndex === 0}
                    >
                        {deals.map((deal, idx) => (
                            <React.Fragment key={deal.id || idx}>
                                <SummaryTypeTextCollection keyName="Deal ID" values={[deal.id]} />
                                <SummaryTypeTextCollection
                                    keyName="Deal Name"
                                    values={[deal.app_name]}
                                />
                                {!isUsingGuaranteedInventoryType(campaign) && (
                                    <SummaryTypeTextCollection
                                        keyName="Deal Type"
                                        values={[DEAL_TYPE_MAPPING[deal.type]?.label || deal.type]}
                                    />
                                )}
                                <SummaryTypeTextCollection
                                    keyName={
                                        deal.category === DealCategory.Curated
                                            ? 'Deal Description'
                                            : 'Deal Publisher Name'
                                    }
                                    values={[deal.pub_name]}
                                />
                                <SummaryTypeTextCollection
                                    keyName="Deal Exchange"
                                    values={[deal.supply_source]}
                                />
                                <SummaryTypeTextCollection
                                    keyName="Deal Price"
                                    values={[
                                        (() => {
                                            if (!deal) return '';
                                            const currencyString = numeral(deal.price_local).format(
                                                '0,0.00'
                                            );
                                            const currencySign = getCurrencySignforCurrency(
                                                deal.currency
                                            );
                                            return `${
                                                deal.currency
                                            } ${currencySign}${currencyString}`;
                                        })(),
                                    ]}
                                />
                                <SummaryTypeTextCollection
                                    keyName="Deal Status"
                                    values={[capitalize(deal.status)]}
                                />
                                {deal.start_date && (
                                    <SummaryTypeTextCollection
                                        keyName="Deal Start Date"
                                        values={[
                                            formatDate_dateWithYear(
                                                deal.start_date,
                                                formData.timezone
                                            ),
                                        ]}
                                    />
                                )}
                                {deal.end_date && (
                                    <SummaryTypeTextCollection
                                        keyName="Deal End Date"
                                        values={[
                                            formatDate_dateWithYear(
                                                deal.end_date,
                                                formData.timezone
                                            ),
                                        ]}
                                    />
                                )}
                                {/* Divider between deals */}
                                {idx < deals.length - 1 && <Divider light />}
                            </React.Fragment>
                        ))}
                    </SummaryGroup>
                ));
            })()}
        </React.Fragment>
    );
};

export default AdSummaryDeals;
